// extracted by mini-css-extract-plugin
export default {"timeline_container":"timeline_timeline_container__gIy5L","year_wrapper":"timeline_year_wrapper__BSG8k","timeline_item":"timeline_timeline_item__zXNY8"};